import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, List } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeList(list: Boundaries["removeList"]["request"]): void;
}

function useListRemoval(list: Identifiable<List>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveListRequestPending(list),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveListRequestSuccess(list),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveListRequestFailure(list),
    ),
    removeList: core.removeList,
  };
}

export { useListRemoval };
